import { updateMetricByKey } from '@client/core/atoms/metrics.js';
import {
  type PlacementId,
  PlacementStatus
} from '@schibsted-nmp/advertising-shared';

/** Fired when an impression becomes viewable. */
export function onImpressionViewable(
  event: googletag.events.ImpressionViewableEvent
) {
  const placementId = event.slot.getSlotElementId() as PlacementId;
  updateMetricByKey(placementId, PlacementStatus.AdViewed);
}
